import httpApiApplication from '../../http/httpApiApplication';

import { baseUrlCollection } from './hooks';
import {
  type CollectionTaxpayer,
  type CreateCollectionRequest,
  type CreateCommunicationRequest
} from './types';

export const createCollection = (request: CreateCollectionRequest): Promise<string> => {
  return httpApiApplication.post(baseUrlCollection, request);
};

export const existTaxpayersForCollectionProcess = async (
  taxId: string,
  maxNumberOfTaxpayers: number
): Promise<boolean> => {
  const result = await httpApiApplication.get<Array<CollectionTaxpayer>>(
    `${baseUrlCollection}/taxpayers?taxId=${taxId}&maximumNumberOfTaxpayers=${maxNumberOfTaxpayers}`
  );
  return result?.length > 0;
};

export const createCommunication = (request: CreateCommunicationRequest): Promise<string> => {
  return httpApiApplication.post(`TaxpayersComunications`, request);
};
